// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"616":"d6532d82","730":"2e5633d1"}[chunkId] + ".chunk.css";
};